import { ActivityPoint } from '@/components/HeatMap';
import { subDays, isSameDay, differenceInDays, isToday } from 'date-fns';

export const getLastInactiveDay = (activity: ActivityPoint[]): Date | null => {
  if (!activity.length) {
    return null;
  }

  const reversedActivity = [...activity].reverse();
  for (let i = 0; i < reversedActivity.length - 1; i++) {
    const date = new Date(reversedActivity[i].date);
    const dayBefore = subDays(date, 1);
    const previousActiveDate = new Date(reversedActivity[i + 1].date);

    if (!isSameDay(dayBefore, previousActiveDate)) {
      return date;
    }
  }

  // TO-DO: This is still not counting today in the streak
  // supposing there is data for today
  return new Date(activity[0].date);
};

export const getCurrentStreak = (activity: ActivityPoint[]): number => {
  const lastActiveDay = activity[activity.length - 1];

  if (!lastActiveDay) {
    return 0;
  }

  const isTodayActive = isToday(new Date(lastActiveDay.date));

  if (!isTodayActive) {
    return 0;
  }

  const lastInActiveDay = getLastInactiveDay(activity);
  if (!lastInActiveDay) {
    return 0;
  }

  const today = new Date();
  const diffInDays = differenceInDays(today, lastInActiveDay);
  const streak = diffInDays + 1;

  return streak;
};
